module.exports = __webpack_public_path__ + "static/clearsplatting_img-66991654e9b5fd0a0e023edc2b73c0e2.png";